module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 04.44.51.97e721d6.png";